import {combineReducers} from "redux"
import types from "actions/types"
import revisionsDrawer from "reducers/quotingContext/selected/approvalDrawer/revisionsDrawer"

export const isOpen = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_SHOW_APPROVAL_DRAWER:
    case types.QUOTING_SHOW_APPROVAL_DRAWER_FOR_ORDER:
      return true
    case types.QUOTING_HIDE_APPROVAL_DRAWER:
      return false
    default:
      return state
  }
}

export const isNew = (state = true, action) => {
  switch (action.type) {
    case types.QUOTING_SHOW_APPROVAL_DRAWER:
      return action.isNewApproval
    case types.QUOTING_SHOW_APPROVAL_DRAWER_FOR_ORDER:
      return true
    case types.QUOTING_ADD_APPROVAL_SUCCESS:
      return false
    default:
      return state
  }
}


export const approvalDetails = (state = {}, action) => {
  switch (action.type) {
    case types.QUOTING_ADD_APPROVAL_SUCCESS:
    case types.QUOTING_ADD_APPROVAL_REVISION_SUCCESS:
      return action.data
    case types.QUOTING_LOAD_APPROVAL_SUCCESS:
      return action.latestRevision
    case types.QUOTING_UPDATE_APPROVAL_SUCCESS:
      return action.updatedRevision
    case types.QUOTING_HIDE_APPROVAL_DRAWER:
      return {}
    case types.QUOTING_SHOW_APPROVAL_DRAWER:
      return action.isNewApproval ? {} : state
    default:
      return state
  }
}

export const approvalDocuments = (state = [], action) => {
  switch (action.type) {
    case types.LOAD_APPROVAL_DOCUMENTS_SUCCESS:
      return action.data
    case types.CLEAR_APPROVAL_DOCUMENTS_ATTEMPT:
      return []
    default:
      return state
  }
}

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_UPDATE_APPROVAL_SUCCESS:
    case types.QUOTING_ADD_APPROVAL_SUCCESS:
    case types.QUOTING_ADD_APPROVAL_REVISION_SUCCESS:
    case types.QUOTING_ADD_APPROVAL_FAILURE:
    case types.QUOTING_UPDATE_APPROVAL_FAILURE:
    case types.QUOTING_ADD_APPROVAL_REVISION_FAILURE:
      return false
    case types.QUOTING_ADD_APPROVAL_ATTEMPT:
    case types.QUOTING_UPDATE_APPROVAL_ATTEMPT:
    case types.QUOTING_ADD_APPROVAL_REVISION_ATTEMPT:
      return true
    default:
      return state
  }
}

export const isLoadingDocuments = (state = false, action) => {
  switch (action.type) {
    case types.LOAD_APPROVAL_DOCUMENTS_ATTEMPT:
    case types.LOAD_APPROVAL_REVISION_DOCUMENTS_ATTEMPT:
      return true
    case types.LOAD_APPROVAL_DOCUMENTS_SUCCESS:
    case types.LOAD_APPROVAL_DOCUMENTS_FAILURE:
    case types.LOAD_APPROVAL_REVISION_DOCUMENTS_SUCCESS:
    case types.LOAD_APPROVAL_REVISION_DOCUMENTS_FAILURE:
    case types.QUOTING_HIDE_APPROVAL_DRAWER:
    case types.QUOTING_SHOW_APPROVAL_DRAWER_FOR_ORDER:
    case types.QUOTING_ADD_APPROVAL_FAILURE:
    case types.QUOTING_UPDATE_APPROVAL_FAILURE:
    case types.QUOTING_ADD_APPROVAL_REVISION_FAILURE:
      return false
    case types.QUOTING_SHOW_APPROVAL_DRAWER:
      return !action.isNewApproval
    default:
      return state
  }
}

export default combineReducers({
  isOpen,
  approvalDetails,
  isNew,
  approvalDocuments,
  isLoading,
  isLoadingDocuments,
  revisionsDrawer,
})
